import { render, staticRenderFns } from "./DefeatMatch.vue?vue&type=template&id=158ab15d&scoped=true&"
import script from "./DefeatMatch.vue?vue&type=script&lang=js&"
export * from "./DefeatMatch.vue?vue&type=script&lang=js&"
import style0 from "./DefeatMatch.vue?vue&type=style&index=0&id=158ab15d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158ab15d",
  null
  
)

export default component.exports